import Nullstack from 'nullstack';
export default function IconBuildingCarousel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-carousel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "6"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "8",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "8",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "16",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "16",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 22l4 -10l4 10"
  }), " ");
}